import ROLES from '@/utils/roles';
import TOP_BARS from '@topBars';
let routes = [
  /**
   * @description 自动打开微信，打开小程序落地页
   * @function /poster/talent-hunt 小程序海报生成页
   * @param { Component } TalentHunt views/Poster/TalentHunt
   * @param { Name } pathname /poster-talent-hunt
   */
  {
    path: '/mini/:id',
    name: 'mini-id',
    meta: {
      title: '哈佛HSYLC峰会'
    },
    component: () => import('@/views/MiniProgram/HsylcX')
  }
];
routes = routes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign({}, ret.meta, {
    topBar: TOP_BARS.NULL
  });
  return ret;
});
export default routes;
